let map;
let infowindow;
let pin;
const markers = [];

// let storeLocations = window.storeLocations || [];

/**
 * An location object
 * @typedef {{lat: number, lng: number}} Location
 */

/**
 * An store object
 * @typedef {{title: string, adress: string, zip: string, city: string, phone: string, lat: number, lng: number, distance: number, url: string, domain_title: string}} Store
 */

/**
 * Init google maps
 */
async function initMap() {
  const input = document.getElementById("map-searchbox");
  const autocomplete = new google.maps.places.Autocomplete(input);
  // Request needed libraries.
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
    "marker"
  );

  map = new Map(document.getElementById("map"), {
    center: { lat: 52.519325, lng: 13.392709 },
    zoom: 4,
    // maxZoom: 14,
    mapId: "2463522056edeba8",
    disableDefaultUI: false,
    zoomControl: true,
    mapTypeControl: true,
    scaleControl: false,
    streetViewControl: true,
    rotateControl: false,
    fullscreenControl: true,
  });

  infowindow = new InfoWindow();
  const pinBackground = new PinElement({
    background: "#FBBC04",
  });

  const locationButton = document.getElementById("mylocation");
  locationButton.addEventListener("click", () => {
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          map.setCenter(pos);
          map.setZoom(8);
        },
        () => {
          handleLocationError(true, infoWindow, map.getCenter());
        }
      );
    } else {
      // Browser doesn't support Geolocation
      handleLocationError(false, infoWindow, map.getCenter());
    }
  });

  const addMarker = (place, index) => {
    const location = {
      lat: place.lat,
      lng: place.lng,
    };

    const marker = new AdvancedMarkerElement({
      map,
      position: location,
      title: place.title,
      // content: pinBackground.element,
    });

    // CONTENT IN MAPS
    const content = `
    ${
      place.title
        ? `<div class="text-secondary-14-125-600 mb-gutter">${place.title}</div>`
        : ""
    }
    ${
      place.domain_title
        ? `<div class="mb-gutter"><a class="text-secondary-14-125 mb-gutter" target="_blank" href="${
            place.url ? place.url : place.domain_title
          }">${place.domain_title}</a></div>`
        : ""
    }
    ${
      place.address || place.zip || place.city
        ? `
      <div class="mb-gutter text-secondary-14-125">
        ${place.address ? `${place.address}<br />` : ""}
        ${
          place.zip || place.city
            ? `${place.zip ?? ""} ${place.city ?? ""}`
            : ""
        }
      </div>`
        : ""
    }
    ${
      place.phone || place.email
        ? `
      <div class="mb-gutter text-secondary-14-125">
        ${place.phone ?? "" ? `${place.phone}<br />` : ""}
        ${place.email ?? "" ? `${place.email}` : ""}
      </div>`
        : ""
    }
  `;

    marker.addListener("click", function () {
      infowindow.setContent(content);
      infowindow.open(map, marker);
      sortStores(location.lat, location.lng);
    });

    markers.push(marker);

    createStore(place, index);
  };

  storeLocations.forEach(
    (place, index) => place.lat && place.lng && addMarker(place, index, false)
  );

  const renderer = {
    render: ({ count, position }) => {
      const svg = window.btoa(`
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <circle cx="24" cy="24" r="24" fill="#FF9826" fill-opacity=".35" />
        <circle cx="24" cy="24" r="23.5" stroke="#000" stroke-opacity=".15" />
        <rect x="12" y="12" width="24" height="24" fill="#FF9826" rx="12" />
      </svg>`);
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(48, 48),
        },
        label: {
          text: String(count),
          color: "rgba(0,0,0,1)",
          fontSize: "10px",
          fontWeight: "600",
        },
        title: `Cluster of ${count} markers`,
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  };

  new markerClusterer.MarkerClusterer({ markers, map, renderer });

  autocomplete.bindTo("bounds", map);
  autocomplete.setFields(["address_components", "geometry", "name"]);

  // Listen for the event fired when the user selects a prediction and retrieve
  // more details for that place.
  autocomplete.addListener("place_changed", function () {
    const place = autocomplete.getPlace();

    if (!place.geometry) {
      console.log("Returned place contains no geometry");
      return;
    }
    const bounds = new google.maps.LatLngBounds();
    // marker.setPosition(place.geometry.location);

    if (place.geometry.viewport) {
      bounds.union(place.geometry.viewport);
    } else {
      bounds.extend(place.geometry.location);
    }

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    // sort list
    sortStores(lat, lng);

    // fitBounds to 3 closest markers to location
    const closest = findClosestLocations(place.geometry.location, 3);
    for (let i = 0; i < closest.length; i++) {
      bounds.extend(closest[i].position);
    }
    map.fitBounds(bounds);
  });

  window.addEventListener("geoLocationUpdated", handleGeoLocation);
}

/**
 *
 * @param {Location} from
 * @param {number} numberOfResults
 * @returns Location[]
 */
function findClosestLocations(from, numberOfResults = 3) {
  const closest = [];
  for (let i = 0; i < markers.length; i++) {
    markers[i].distance = google.maps.geometry.spherical.computeDistanceBetween(
      from,
      markers[i].position
    );
    closest.push(markers[i]);
  }
  closest.sort((a, b) => a.distance - b.distance);
  return closest.splice(0, numberOfResults);
}

/**
 * Appends store HTML to #stores
 * @param {Store} place - Store object
 */
function createStore(place, index) {
  const store = document.createElement("div");
  store.dataset.lat = place.lat;
  store.dataset.lng = place.lng;
  store.dataset.index = index;
  store.classList.add("store");

  const header = document.createElement("div");
  header.classList.add("pb-gutter", "text-secondary-16-120");
  header.innerHTML = place.city;

  const content = document.createElement("div");
  content.classList.add(
    "border-b",
    "border-black-mud-15",
    "lg:grid",
    "lg:grid-cols-12",
    "gap-6",
    "pt-gutter",
    "pb-24",
    "mb-24"
  );

  // CONTENT IN LIST
  const divLeft = document.createElement("div");
  divLeft.classList.add("col-span-4");
  divLeft.innerHTML = `<div class="text-secondary-14-125-600 mb-6">${place.title}</div>`;
  divLeft.innerHTML += place.domain_title
    ? `<div class="mt-6 mb-6"><a class="text-secondary-14-125" target="_blank" href="${
        place.url ? place.url : place.domain_title
      }">${place.domain_title}</a></div>`
    : "";
  divLeft.innerHTML += `${place.address}<br />${place.zip} ${place.city}`;
  content.appendChild(divLeft);

  const divRight = document.createElement("div");
  divRight.classList.add("col-span-4");
  content.appendChild(divRight);

  const contact = document.createElement("p");
  contact.innerHTML = `<div class="text-secondary-14-125-600 mb-6 max-md:mt-12">${strings.contact}</div>`;
  contact.innerHTML += place.email ? `${place.email}<br />` : "";
  contact.innerHTML += place.phone ? place.phone : "";

  divRight.appendChild(contact);

  store.appendChild(header);
  store.appendChild(content);
  stores.appendChild(store);
}

function fitBoundsToMarkers(markers) {
  const bounds = new google.maps.LatLngBounds();
  for (let i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].position);
  }
  map.fitBounds(bounds);
}

function handleGeoLocation(event) {
  const geoLocation = event.detail.message;
  if (geoLocation && geoLocation.coords) {
    const location = {
      lat: geoLocation.coords.latitude,
      lng: geoLocation.coords.longitude,
    };
    const closest = findClosestLocations(location, 3);
    // closest.unshift(location);
    fitBoundsToMarkers(closest);
    sortStores(location.lat, location.lng);
  }
}

const getDistance = (x1, x2, y1, y2) => {
  const y = x2 - x1;
  const x = y2 - y1;

  return Math.sqrt(x * x + y * y);
};

// Function to sort Data
function sortStores(lat, lng) {
  // add distance from marker to location
  const stores = document.querySelectorAll(".store");
  stores.forEach((store) => {
    store.dataset.distance = getDistance(
      store.dataset.lat,
      lat,
      store.dataset.lng,
      lng
    );
  });

  const subjectsArray = Array.from(stores);

  const sorted = subjectsArray.sort((divA, divB) => {
    const a = parseFloat(divA.dataset.distance);
    const b = parseFloat(divB.dataset.distance);
    return a - b;
  });

  stores.innerHTML = "";
  sorted.forEach((e) => document.querySelector("#stores").appendChild(e));
  return sorted;
}

window.initMap = initMap;
